<template>
  <Block v-if="retributionsAnalytics" badge-class="bg-green-50" emoji="🚀" class="mt-6">
    <template #title>
      <h3 class="text-xl font-bold tracking-tight text-black">Booster magasin</h3>
    </template>

    <template #actions>
      <div class="flex items-stretch divide-x divide-gray-200 shrink-0">
        <div class="px-4 text-right">
          <div class="uppercase tracking-wider text-gray-400 font-semibold text-xs">Ventes</div>
          <div class="text-gray-900 font-extrabold text-lg tabular-nums leading-tight">
            {{ totalSales }}
          </div>
        </div>
        <div class="px-4 text-right">
          <div class="uppercase tracking-wider text-gray-400 font-semibold text-xs">Prochain palier</div>
          <div class="text-gray-900 font-extrabold text-lg tabular-nums leading-tight">
            <template v-if="nextTier">
              {{ $t("roadmap.sales", nextTier.threshold - totalSales) }}
            </template>
            <template v-else>—</template>
          </div>
        </div>
        <div class="px-4 text-right">
          <div class="uppercase tracking-wider text-gray-400 font-semibold text-xs">Bonus actif</div>
          <div
            class="font-extrabold text-lg tabular-nums leading-tight"
            :class="reachedTier ? 'text-primary-dark' : 'text-gray-300'"
          >
            <template v-if="reachedTier">+{{ multiplierPercentage(reachedTier.multiplicator) }}%</template>
            <template v-else>—</template>
          </div>
        </div>
      </div>
    </template>

    <div class="px-5 pb-5">
      <div class="grid grid-cols-3 gap-4">
        <div v-for="(t, i) in boosterThresholds" :key="t.tier" class="min-w-0">
          <div class="flex items-baseline justify-between mb-1.5 tabular-nums">
            <span class="font-bold uppercase tracking-wider text-xs" :class="tierColorClass(t)">
              Palier {{ t.tier }}
            </span>
            <span class="text-sm font-extrabold" :class="tierColorClass(t)">
              +{{ multiplierPercentage(t.multiplicator) }}%
            </span>
          </div>
          <ProgressionBar :max="tierMax(t, i)" :value="tierValue(t, i)" size="h-1.5" />
          <div class="text-xs tabular-nums mt-1.5 font-semibold" :class="tierColorClass(t)">
            {{ $t("roadmap.sales", t.threshold) }}
          </div>
        </div>
      </div>
    </div>
  </Block>
</template>

<script>
import { boosterThresholds, getReachedTier, getNextTier, multiplierPercentage } from "@/utils/booster";
import { Block, ProgressionBar } from "@estaly/ui";

export default {
  name: "Booster",
  components: { Block, ProgressionBar },
  props: {
    retributionsAnalytics: { type: Object, default: null },
  },
  data() {
    return { boosterThresholds };
  },
  computed: {
    totalSales() {
      if (!this.retributionsAnalytics?.ranking?.length) return 0;
      return this.retributionsAnalytics.ranking.reduce((acc, item) => acc + (item.totalRetributions || 0), 0);
    },
    reachedTier() {
      return getReachedTier(this.totalSales, this.boosterThresholds);
    },
    nextTier() {
      return getNextTier(this.totalSales, this.boosterThresholds);
    },
  },
  methods: {
    multiplierPercentage,

    tierColorClass(t) {
      if (this.totalSales >= t.threshold) return "text-primary-dark";
      if (this.nextTier && t.tier === this.nextTier.tier) return "text-gray-900";
      return "text-gray-400";
    },

    tierMax(t, i) {
      const start = i === 0 ? 0 : this.boosterThresholds[i - 1].threshold;
      return t.threshold - start;
    },

    tierValue(t, i) {
      const start = i === 0 ? 0 : this.boosterThresholds[i - 1].threshold;
      const end = t.threshold;
      if (this.totalSales >= end) return end - start;
      if (this.totalSales > start) return this.totalSales - start;
      return 0;
    },
  },
};
</script>
